// tslint:disable: variable-name
import { Usuario } from 'eddydata-lib';
import { EspecieAlmoxarifado } from '../../components/types';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from '../comum/orgao.model';

export class MovimentoEstoqueTipo extends BaseResourceModel {
  constructor(
    public id?: number,
    public tipo?: string,
    public entrada?: boolean,
    public obs_obrigatorio?: boolean,
    public inativo?: boolean,
    public justificativa_inativo?: string,
    public data_inativo?: Date,
    public usuario_inativo?: Usuario,
    public especie?: EspecieAlmoxarifado,
    public orgao?: Orgao,
  ) {
    super();
  }

  static converteJson(json: any): MovimentoEstoqueTipo {
    return Object.assign(new MovimentoEstoqueTipo(), json);
  }
}
